import { NgModule } from '@angular/core';
import { MyShopStoreModule } from './store/my-shop-store.module';

@NgModule({
  imports: [MyShopStoreModule],
})
export class MyShopDataAccessModule {}
